import ModalCommon from './ModalCommon';

export default ModalCommon;
